import FadeIn from "react-fade-in";
import PaginationButtons from "../../atom/pagination";
import TableTopBar from "../modal/tableTopBar";
import { Backdrop } from "@mui/material";
import Lottiefy from "../../atom/lottie/lottie";
import * as loaderLottie from "../../utils/lottie/loaderLottie.json";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  EditPencilIcon,
  TableSortIconDownArrow,
} from "../../utils/icons/defaultIcons";
import {
  getTenantUsers,
  getTenantUsersCSV,
  getToken,
} from "../../services/api";
import { setProvisionData } from "../../toolkit/reducers/provisionedUserDataSlice";
import { setBreadcrumbs } from "../../toolkit/reducers/breadCrumbsSlice";
import { getENVData } from "../../config/environment";
import Table from "../../atom/table";
import { downloadFileFromURL } from "../../services/utilities";

function TenantUsersTab() {
  const [manageState, setManageState] = useState<string>("");
  const [tableData, setTableData] = useState<any>([]);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [pageCount, setPageCount] = useState<number>(0);
  const [perPage, setPerPage] = useState<number>(25);
  const [resultNotFound, setResultNotFound] = useState<boolean>(false);
  const [loader, setLoader] = useState<boolean>(false);
  const [csvDownload, setCsvDownload] = useState<boolean>(false);

  const token = useSelector((state: any) => state.auth.token);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const id = getToken();

  const [tableTitles, setTableTitles] = useState<any>([
    {
      key: "email",
      title: "Email",
      icon: <TableSortIconDownArrow />,
      sort: { direction: "asc", active: true },
    },
    {
      key: "firstname",
      title: "First Name",
      icon: <TableSortIconDownArrow />,
      sort: { direction: "asc", active: false },
    },
    {
      key: "lastname",
      title: "Last Name",
      icon: <TableSortIconDownArrow />,
      sort: { direction: "asc", active: false },
    },
    {
      key: "status",
      title: "Status",
      type: "bubbleStatus",
      icon: <TableSortIconDownArrow />,
      sort: { direction: "asc", active: false },
    },
    // {
    //   key: "owner",
    //   title: "Tenant",
    //   icon: <TableSortIconDownArrow />,
    //   sort: { direction: "asc", active: false },
    // },
    {
      key: "action_button",
      title: "",
      type: "actionIcon",
      class: "",
      icon: <EditPencilIcon />,
      action: {
        title: "Manage",
        command: "manage",
        action: "click",
      },
    },
  ]);

  const getProvision = (pNUm: number) => {
    setPageNumber(pNUm);
    onHandleSearch({ pageNumber: pNUm });
  };

  const [searchtext, setSearchText] = useState<any>("");
  const [sort, setSort] = useState<any>({
    key: "email",
    order: "ASC",
  });
  const [handleKeyPress, setHandleKeyPress] = useState<boolean>(true);

  const onHandleSearch: any = (options: {
    limit?: number;
    searchtext?: string;
    pageNumber?: number;
    sort_column?: string;
    sort_direction?: string;
  }) => {
    setLoader(true);
    getTenantUsers(
      {
        limit: options?.limit || perPage,
        pageId: options?.pageNumber || pageNumber,
        sort_column: options?.sort_column || sort.key,
        sort_direction: options?.sort_direction || sort.order,
        searchtext:
          options?.searchtext === undefined
            ? searchtext
            : options?.searchtext === ""
              ? ""
              : options?.searchtext,
      },
      id,
    ).then((resultData: any) => {
      const result: any = resultData?.data?.data || [];
      if (!resultData?.success || result?.length === 0) {
        setLoader(false);
        setResultNotFound(true);
      } else {
        setResultNotFound(false);
        setToggleDropdown(
          toggleDropdown.map((item: any) => ({
            ...item,
            checked: resultData?.data[item.key] ?? false, // default to false if key is missing
          })),
        );
      }
      setPageCount(resultData.data.total_count);
      setTableData(result);
      setLoader(false);
      dispatch(setProvisionData(result));
    });
  };
  // const handleToggleChange = (data: any) => {
  //   console.log("togglealldata", data);
  //   const payload = {
  //     [data.key]: !data.checked,
  //   };
  //   updateSoftphoneAllToggle(id, payload).then((result: any) => {
  //     if (!result.success) {
  //       let msg = result?.message;
  //       Notification(
  //         "Failed",
  //         msg?.charAt(0).toUpperCase() + msg.slice(1),
  //         "danger"
  //       );
  //     } else {
  //       getProvision(pageNumber);
  //       setToggleDropdown(
  //         toggleDropdown.map((node: any) => {
  //           if (node.key === data.key) {
  //             return { ...node, checked: !node.checked };
  //           }
  //           return node;
  //         })
  //       );
  //     }
  //   });
  // };

  const [toggleDropdown, setToggleDropdown] = useState<any>([
    {
      title: "Softphone",
      key: "enable_softphone_all",
      checked: false,
    },
  ]);

  const handleSearch = (data: string) => {
    setPageNumber(1);
    setSearchText(data);
    onHandleSearch({ searchtext: data, pageNumber: 1, limit: perPage });
  };
  const onHandleSort = (node: any, orderBy: string) => {
    setSort({ key: node.key, order: orderBy });
    onHandleSearch({ sort_column: node.key, sort_direction: orderBy });
  };
  const onhandleStateChange = (state: any) => {
    console.log("state", state);
    navigate(`${state}`, { replace: false });
  };
  const activeBreadCrumbs = useSelector(
    (state: any) => state.BreadCrumbsList.brudCrubName,
  );
  const TeanantName = useSelector(
    (state: any) => state.BreadCrumbsList.tenantName,
  );
  useEffect(() => {
    getProvision(1);
  }, []);
  //   useEffect(() => {
  //     if (TeanantName !== "") {
  //       var res = [...activeBreadCrumbs];
  //       res[2] = {
  //         display: `Manage ${TeanantName}`,
  //         path: "provision/tenants/" + id + "/basic",
  //       };
  //       res[3] = {
  //         display: "users",
  //         path: "provision/tenants/" + id + "/users",
  //       };
  //       dispatch(setBreadcrumbs(res));
  //     }
  //   }, [TeanantName]);
  const handleChange = (pNUm: number) => {
    getProvision(pNUm);
    setPageNumber(pNUm);
  };
  const handlePerPage = (value: any) => {
    value = parseInt(value);
    setPerPage(value);
    setPageNumber(1);
    onHandleSearch({ limit: value, pageNumber: 1 });
  };
  const actionHandler = (action: string, data: any, index: number) => {
    console.log("action", action);
    if (action === "Provision user") {
      action = "provisionuser";
    }
    const actionsMap: any = {
      manage: onhandleStateChange,
      provisionuser: onhandleStateChange,
    };
    const act = actionsMap[action];
    if (act) {
      act(action);
    } else {
      console.log("actionHandler Error");
    }
  };

  const handleCSVDownload = () => {
    console.log(sort.key, "sort.key");
    setCsvDownload(true);

    let payload = {
      sort_column: sort.key,
      sort_direction: sort.order,
    };
    //vaspian-dev.vaspian.com/v2/tenants/ffff52e9-147e-4e29-ab98-55405af1b89c/
    https: getTenantUsersCSV(id).then((result: any) => {
      if (result.data) {
        const baseURL = `${getENVData().baseURL}tenant/${id}/tenant_users/download/csv/`;
        const url = `${baseURL}${result?.data.path.replace(
          "/opt/msa_provisioner/var/tmp/",
          "",
        )}`;
        downloadFileFromURL(url, "Tenant Users", token)
          .then((result: any) => {
            if (!result) {
              console.error("Download Failed");
            }
            setCsvDownload(false);
          })
          .catch((error: any) => {
            setCsvDownload(false);
            console.error("Download Failed");
          });
      } else {
        setCsvDownload(false);
        console.error("Download Failed");
      }
    });
  };
  return (
    <div>
      <div className="h-full py-3 flex relative gap-2.5 rounded-md ">
        <Backdrop className="!z-[99999999999]" open={loader}>
          {/* <CircularProgress color="inherit" /> */}
          <Lottiefy loop={true} json={loaderLottie} height={100} width={100} />
          {/* <Lottiefy loop={true} json={trial} height={100} width={100} /> */}
        </Backdrop>
        <div className="h-[calc(100vh-125px)] lg:w-[calc(100vw-125px)] w-[calc(100vw-90px)] overflow-y-auto min-w-max rounded-md">
          <FadeIn>
            <div className="pt-3">
              <TableTopBar
                title={"Users"}
                button={true}
                manageState={manageState}
                setManageState={setManageState}
                onhandleStateChange={onhandleStateChange}
                permission={"provision.users.post"}
                buttonText={"Provision user"}
                search={true}
                searchtext={searchtext}
                setSearchText={setSearchText}
                handleSearch={handleSearch}
                handleKeyPress={handleKeyPress}
                setHandleKeyPress={setHandleKeyPress}
                actionHandler={actionHandler}
                CSV={true}
                handleCSVDownload={handleCSVDownload}
                csvDownload={csvDownload}
                // toggleDropdown={toggleDropdown}
                // handleToggleChange={handleToggleChange}
              />
            </div>

            <Table
              tableTitles={tableTitles}
              tableData={tableData}
              setTableData={setTableData}
              actionHandler={actionHandler}
              setTableTitles={setTableTitles}
              button={true}
              onHandleSort={onHandleSort}
              buttonIndex={4}
              buttonText1={"manage"}
              width={
                "lg:w-[calc(100vw-122px)] w-[calc(100vw-90px)] overflow-auto"
              }
              scrollHeight={"h-[calc(100vh-415px)] overflow-y-auto"}
              manageState={manageState}
              setManageState={setManageState}
              onhandleStateChange={onhandleStateChange}
              permission={"provision.users.put"}
              actions={true}
              resultNotFound={resultNotFound}
            />
            {!resultNotFound && tableData.length > 0 && (
              <PaginationButtons
                pageNumber={pageNumber}
                handleChange={handleChange}
                pageCount={pageCount}
                perPage={perPage}
                handlePerPage={handlePerPage}
                enableAll={true}
              />
            )}
          </FadeIn>
        </div>
      </div>
    </div>
  );
}
export default TenantUsersTab;
